import styled from 'styled-components';

import { useGetDashboardGroupSummary } from 'hooks/queries/dashboard';
import useGetSearchParams from 'hooks/useGetSearchParams';
import {
	EmphasizeText,
	ReportSectionCard,
	ReportTopHeader,
} from 'styles/styled-components/report';
import style from 'styles/styled-components/style';

import MissionProgressGraph from './MissionProgressGraph';

const MissionProgressCard = () => {
	const [groupId] = useGetSearchParams(['groupId']);

	const { data: groupSummary, isLoading } = useGetDashboardGroupSummary(groupId);
	const missionList = groupSummary?.missionStatus.slice(0, 3);

	return (
		<>
			{missionList?.map((mission) => (
				<ReportSectionCard key={mission.missionNumber} _width="349px">
					<Grid _height="100%" direction="column" flex="between">
						<ReportTopHeader>{mission.missionNumber}차 미션</ReportTopHeader>
						<MissionProgressWrapper
							flex="start"
							_padding="10px 12px"
							_margin="0 0 30px 0"
						>
							<Grid>
								<EmphasizeText>릴스</EmphasizeText>
								<Grid flex="start" _gap="20px">
									<EmphasizeText>
										<span>{mission.reelsUpload.completed}</span> <p>정상 진행</p>
									</EmphasizeText>
									<EmphasizeText>
										<span>{mission.reelsUpload.notStarted}</span> <p>미수행</p>
									</EmphasizeText>
								</Grid>
							</Grid>
							<GrayLine />
							<Grid>
								<EmphasizeText>스타일클립</EmphasizeText>
								<Grid flex="start" _gap="20px">
									<EmphasizeText>
										<span>{mission.styleClipUpload.completed}</span> <p>정상 진행</p>
									</EmphasizeText>
									<EmphasizeText>
										<span>{mission.styleClipUpload.notStarted}</span> <p>미수행</p>
									</EmphasizeText>
								</Grid>
							</Grid>
						</MissionProgressWrapper>
						<MissionProgressGraph
							contractedMembers={groupSummary?.memberStatus.contractedMembers}
							productPurchase={{ count: mission.productPurchase.completed }}
							draftSend={{ count: mission.draftSend?.completed ?? 0 }}
							reelsUpload={{ count: mission.reelsUpload.completed }}
							styleClipUpload={{ count: mission.styleClipUpload.completed }}
						/>
					</Grid>
				</ReportSectionCard>
			))}
		</>
	);
};

const { Grid } = style;

const GrayLine = styled.div`
	width: 1px;
	height: 75px;
	margin: 0 20px;
	background-color: ${({ theme }) => theme.colors.gray.gray10};
`;

const MissionProgressWrapper = styled(Grid)`
	background-color: ${({ theme }) => theme.colors.gray.gray05_bg};
	border-radius: 6px;
`;

export default MissionProgressCard;
